export const EDIT_AD_PAGE_SLUG_INDEX = 3;
export const AD_PAGE_SLUGS_COUNT = 3;
export const LEGACY_ID_SLUG_INDEX = 2;

export const NEW_AD_PAGE_SLUG = 'new';
export const VIP_ADS_PAGE_SLUG = 'vip';
export const EDIT_AD_PAGE_SLUG = 'ad_edits';
